import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=0fbabfe7&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=0fbabfe7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_css-loader@6.11.0_webpack@5.94.0__handlebar_2aedba235eac052937d84807a282dc7b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbabfe7",
  null
  
)

export default component.exports